import { useEffect, useState } from "react";
import { Reveal, Eyebrow } from "./Reveal";
import { api, mediaUrl } from "../../lib/api";

export default function Team() {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    api.getTeam().then(setMembers).catch(() => {});
  }, []);

  return (
    <section id="team" className="relative py-24 md:py-36 bg-obsidian" data-testid="team-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <Eyebrow index="09" label="THE VOICES" />
          <h2 className="font-display text-cream text-6xl md:text-8xl tracking-tight leading-[0.85]" data-testid="team-heading">
            MEET THE <span className="text-burnt">TEAM.</span>
          </h2>
          <p className="mt-6 max-w-md text-sand font-light leading-relaxed">
            Creating the conversations, experiences, and digital spaces that move culture forward.
          </p>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="team-grid">
          {members.map((m, i) => (
            <Reveal key={m.id} delay={0.08 * i}>
              <div className="group border border-woodborder bg-card/40 overflow-hidden hover:border-tan/40 transition-colors duration-500" data-testid={`team-member-${i}`}>
                <div className="aspect-[4/5] relative overflow-hidden">
                  {m.photo ? (
                    <div className="w-full h-full" style={{ background: "linear-gradient(165deg, #2A1D12 0%, #14100E 50%, rgba(200,90,23,0.4) 115%)" }}>
                      <img
                        src={mediaUrl(m.photo)} alt={m.name} loading="lazy"
                        className="w-full h-full object-contain object-bottom pt-8 grayscale-[0.35] group-hover:grayscale-0 group-hover:scale-[1.03] transition-all duration-700"
                      />
                    </div>
                  ) : (
                    <div
                      className="w-full h-full flex flex-col items-center justify-center"
                      style={{ background: "linear-gradient(160deg, #1E1915 0%, #14100E 55%, rgba(200,90,23,0.18) 100%)" }}
                      data-testid={`team-photo-placeholder-${i}`}
                    >
                      <span className="font-display text-[6.5rem] leading-none text-tan/25 select-none">{m.name.charAt(0)}</span>
                      <span className="mt-5 font-mono text-[9px] tracking-[0.3em] text-clay border border-woodborder px-3 py-1.5">PORTRAIT LOADING</span>
                    </div>
                  )}
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-obsidian via-obsidian/75 to-transparent p-6 pt-20">
                    <h3 className="font-display text-4xl text-cream tracking-wide" data-testid={`team-name-${i}`}>{m.name}</h3>
                    <p className="mt-1 font-mono text-[10px] tracking-[0.2em] text-gold-bright" data-testid={`team-title-${i}`}>{(m.title || "").toUpperCase()}</p>
                  </div>
                </div>
                {m.intro && (
                  <p className="p-5 text-sand text-sm font-light leading-relaxed border-t border-woodborder" data-testid={`team-intro-${i}`}>{m.intro}</p>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
